import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import { FormattedMessage } from "react-intl";
import { DropdownButton, MenuItem } from "react-bootstrap";

// Components used in OptionsMenu need to have their main action button have the ref "action" to work

class OptionsMenu extends React.Component {
  activateComponent(i) {
    const element = ReactDOM.findDOMNode(this.refs[`item${i}`]);
    for (let key in element) {
      if (key.startsWith("__reactInternalInstance$")) {
        const instance = element[key]._currentElement._owner._instance;
        const action = instance.refs.action;
        action.click ? action.click() : action.props.onClick();
        break;
      }
    }
  }

  render() {
    const options = this.props.options.filter(
      (option) => option.requirement !== false
    );

    const hasOptions = Array.isArray(options) && options.length > 0;

    return (hasOptions &&
      <div className="options-menu">
        <div id="menu-options" style={{ display: "none" }}>
          {options.map((child, i) => {
            return (
              <span key={`options-menu-component-${i}`}>
                {React.cloneElement(child.component, { ref: `item${i}` })}
              </span>
            );
          })}
        </div>
        <DropdownButton
          id="options-menu"
          onClick={this.props.onClick}
          pullRight
          title=""
        >
          {options.map((child, i) => {
            return (
              <MenuItem
                key={`options-menu-button-${i}`}
                eventKey={i}
                onClick={this.activateComponent.bind(this, i)}
              >
                {child.icon}
                <FormattedMessage
                  id={child.label}
                  values={child.labelParameters}
                />
              </MenuItem>
            );
          })}
        </DropdownButton>
      </div>
    );
  }
}

OptionsMenu.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.node.isRequired,
      icon: PropTypes.node,
      label: PropTypes.string.isRequired,
      labelParameters: PropTypes.objectOf(PropTypes.string),
      requirement: PropTypes.bool,
    })
  ),
};

export default OptionsMenu;



// WEBPACK FOOTER //
// ./src/components/common/OptionsMenu.js